import { Redirect } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { LOGIN_STATUS } from './loginConstants'
import FullPageLoading from '../../components/loading/FullPageLoading'

const OtpLogin = () => {
  const { adAccountId } = Object.fromEntries(
    new URLSearchParams(window.location.search)
  )
  const { loginStatus } = useSelector(state => state.login)
  return loginStatus === LOGIN_STATUS.SUCCESS ? (
    <Redirect to={`/${adAccountId}/dashboard`} />
  ) : (
    <FullPageLoading />
  )
}
export default OtpLogin
